export enum LogisticsRequestStateEnum {
  New = 'new',
  sent = 'sent',
  InProgress = 'in_progress',
  Closed = 'closed',
}
